module.exports = __webpack_public_path__ + "img/menu_gpxEdit.5900fb31.png";